type Options = Partial<GalleryMobileSliderDesktopScrollerOptions>;

import _ from 'lodash';
import {TinySliderInstance, tns} from 'tiny-slider/src/tiny-slider';
import 'tiny-slider/src/tiny-slider.scss';
import './gallery.pcss';

export interface GalleryMobileSliderDesktopScrollerOptions {
  breakpoint: number;
  containerID: string;
  imageClass: string;
  summaryElementID: string;
  thumbnailElementID: string;
  thumbnailWrapperElementID: string;
}

export class GalleryMobileSliderDesktopScroller {
  static defaults = {
    breakpoint: 928,
    containerID: 'product',
    imageClass: 'image-',
    summaryElementID: 'product-summary',
    thumbnailElementID: 'gallery__thumbs__content',
    thumbnailWrapperElementID: 'gallery__thumbs',
  };

  tinySlider: TinySliderInstance;
  options: GalleryMobileSliderDesktopScrollerOptions;
  scrollerClickEventAlreadyBound = false;

  constructor(options: Options = {}) {
    this.options = {
      ...GalleryMobileSliderDesktopScroller.defaults,
      ...options,
    };

    this.init();
  }

  init() {
    this.handleResize();

    window.addEventListener(
      'resize',
      _.debounce(this.handleResize.bind(this, this.options.breakpoint), 150),
    );

    window.addEventListener(
      'scroll',
      _.debounce(
        this.scrollerStickElements.bind(
          this,
          this.options.summaryElementID,
          this.options.thumbnailElementID,
          this.options.thumbnailWrapperElementID,
        ),
        0,
      ),
    );
  }

  isMobile() {
    return window.innerWidth < this.options.breakpoint;
  }

  handleResize() {
    if (this.isMobile()) {
      this.createSlider();
      this.destroyScroller();
    } else {
      this.destroySlider();
      this.createScroller();
    }
  }

  createSlider() {
    if (this.tinySlider && this.tinySlider.isOn) {
      return;
    }

    this.tinySlider = tns({
      center: true,
      container: '[data-tinyslider]',
      controls: false,
      gutter: 10,
      navPosition: 'bottom',
    });
  }

  destroySlider() {
    if (this.tinySlider) {
      this.tinySlider.destroy();
    }
  }

  createScroller() {
    if (!this.scrollerClickEventAlreadyBound) {
      const targets = Array.from(
        document.querySelectorAll('.gallery__thumb-item'),
      );

      for (const each of targets) {
        each.addEventListener('click', () =>
          this.scrollerHandleClick(event as Event),
        );
      }

      this.scrollerClickEventAlreadyBound = true;
    }
  }

  scrollerHandleClick(event: Event) {
    const element = event.target as HTMLElement;
    const id = element.id;
    const target = this.options.imageClass + id;
    const targetElement = document.getElementById(target)!;

    let offsetTop = targetElement.offsetTop;

    const header = document.getElementById('header')!;

    if (header.classList.contains('is-sticky')) {
      offsetTop += header.offsetHeight;
    }

    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: offsetTop,
    });
  }

  scrollerStickElements() {
    const containerElement = document.getElementById(this.options.containerID);
    const summaryElement = document.getElementById(
      this.options.summaryElementID,
    );
    const thumbnailElement = document.getElementById(
      this.options.thumbnailElementID,
    );

    if (!containerElement || !summaryElement) {
      return;
    }

    if (!this.isMobile()) {
      let scrollOffset = containerElement.offsetTop;
      scrollOffset -= 20;
      const header = document.getElementById('header')!;

      if (header.classList.contains('is-sticky')) {
        scrollOffset -= header.offsetHeight;
      }

      if (window.scrollY >= scrollOffset) {
        this.makeSticky(summaryElement, header);
        if (thumbnailElement) {
          this.makeSticky(thumbnailElement, header);
        }
      }
    } else {
      this.makeStatic(summaryElement);
      if (thumbnailElement) {
        this.makeStatic(thumbnailElement);
      }
    }
  }

  makeSticky(element: HTMLElement, header: HTMLElement) {
    if (element) {
      element.classList.add('is-stuck');
      element.style.top = `${header.offsetHeight + 50}px`;
    }
  }

  makeStatic(element: HTMLElement) {
    element.style.position = '';
    element.classList.remove('is-stuck');
  }

  destroyScroller() {
    const targets = Array.from(
      document.querySelectorAll('.gallery__thumb-item'),
    );

    for (const each of targets) {
      each.removeEventListener('click', () =>
        this.scrollerHandleClick(event as Event),
      );
    }
  }
}
